<template>
  <el-table-column
    prop="error"
    sortable="custom"
    label="Hibaüzenet"
    show-overflow-tooltip
    min-width="200"
    show-tooltip-when-overflow
    align="center"
  >
    <template slot-scope="scope">
      {{ scope.row.error }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'error',
};
</script>
